// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Emergency Contact page — scoped under .ec-page */

.ec-page {
  width: 100%;
  min-height: 100%;
  padding: 35px 24px 48px;
  max-width: 1190px;
  margin: 0 auto;
}

.ec-page *,
.ec-page *::before,
.ec-page *::after {
  box-sizing: border-box;
}

.ec-page__crumbs {
  margin-bottom: 18px;
}

.ec-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8e939c;
  font-size: 15px;
  font-weight: 500;
}

.ec-page__crumbItem--active {
  color: #e0e0e0;
}

body.light_theme .ec-page__crumbItem--active {
  color: #101828;
}

.ec-page__crumbSep {
  color: #8e939c;
}

.ec-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.ec-page__crumbLink:hover {
  color: #e9e9e9;
  text-decoration: underline;
  text-underline-offset: 3px;
}

body.light_theme .ec-page__crumbLink:hover {
  color: #101828;
}

.ec-page__title {
  margin: 42px 32px 28px;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #e2e2e2;
  text-align: left;
}

body.light_theme .ec-page__title {
  color: #2d2e32;
}

.ec-page__art {
  max-width: 220px;
  display: flex;
  justify-content: center;
  margin: 50px auto;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
}

.ec-page__artImg {
  width: min(280px, 86vw);
  height: auto;
  display: block;
}

.ec-page__body {
  margin: 0 0 28px;
  font-size: 18px;
  line-height: 1.65;
  font-weight: 500;
  color: #919191;
  text-align: left;
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}

body.light_theme .ec-page__body {
  color: #4a5565;
}

.ec-how {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  margin: 0 0 28px;
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}

.ec-how__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #f3f4f6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #4a5565;
  font-size: 22px;
  flex-shrink: 0;
}

.ec-how__text {
  min-width: 0;
}

.ec-how__title {
  font-size: 16px;
  font-weight: 500;
  color: #2d2e32;
  margin-bottom: 2px;
}

.ec-how__learn {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: #ac8a50;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.ec-page__cta {
  display: block;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  height: 50px;
  border: none;
  border-radius: 999px;
  background: #2d2e32;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

.ec-page__cta:hover {
  opacity: 0.8;
}

@media (max-width: 520px) {
  .ec-page {
    padding: 30px 16px 40px;
  }


}

/* —— Add Emergency Contact modal (layout aligned with design) —— */

.ec-modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  /* Below App.js <Toaster containerStyle zIndex> so react-hot-toast errors stay visible */
  z-index: 999999999;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

body.light_theme .ec-modal-overlay {
  background-color: rgb(255 255 255 / 20%);
}

.ec-modal {
  width: 100%;
  max-width: 510px;
  max-height: min(92vh, 720px);
  overflow-y: auto;
  background: #1e202670;
  border-radius: 20px;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  padding: 16px 20px 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
  position: relative;
}

body.light_theme .ec-modal {
  background: rgb(255 255 255 / 20%);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
}

.ec-modal__header {
  position: relative;
  min-height: 40px;
  margin: 0;
  background-color: transparent !important;
  padding: 0;
}

.ec-modal__back {
  position: absolute;
  left: -4px;
  top: 0;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  border-radius: 10px;
  color: #f0f0f0;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

body.light_theme .ec-modal__back {
  color: #101828;
}

.ec-modal__back:hover {
  background: rgba(255, 255, 255, 0.08);
}

body.light_theme .ec-modal__back:hover {
  background: #f3f4f6;
}

.ec-modal__back:focus-visible {
  outline: 2px solid #ac8a50;
  outline-offset: 2px;
}

.ec-modal__title {
  margin: 0px 0 0;
  padding: 0 0 0 2px;
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: -0.03em;
  line-height: 1.25;
  text-align: left;
}

body.light_theme .ec-modal__title {
  color: #101828;
}

.ec-modal__form {
  margin: 0;
  padding: 0;
}

.ec-modal__block {
  margin: 24px 0 0;
  padding: 0;
  border: none;
}

.ec-modal__block:first-of-type {
  margin-top: 22px;
}

.ec-modal__blockTitle {
  margin: 0 0 10px;
  padding: 0;
  font-size: 15px;
  font-weight: 600;
  color: #f0f0f0;
  text-align: left;
  line-height: 1.3;
}

body.light_theme .ec-modal__blockTitle {
  color: #101828;
}

.ec-modal__input {
  display: block;
  width: 100%;
  height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  padding: 0 16px;
  font-size: 15px;
  font-weight: 500;
  color: #f0f0f0 !important;
  outline: none;
  box-sizing: border-box;
}

body.light_theme .ec-modal__input {
  border: 1px solid #e8eaed;
  background: #f3f4f6;
  color: #3c3c3c !important;
}

.ec-modal__input::placeholder {
  color: #94a3b8;
  font-weight: 500;
}

body.light_theme .ec-modal__input::placeholder {
  color: #3c3c3c !important;
}

.ec-modal__input:focus {
  border-color: #ac8a50;
  background: rgba(255, 255, 255, 0.08);
}

body.light_theme .ec-modal__input:focus {
  border-color: #cfd4dc;
  background: #ffffff;
}

.ec-modal__contactStack {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ec-modal__row {
  margin: 0;
}

.ec-modal__phone {
  width: 100%;
}

/* Unified phone row — same horizontal layout as login/signup (country | divider | number) */
.ec-modal__phone .auth-phone-field {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 50px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.04);
  box-sizing: border-box;
  overflow: hidden;
}

body.light_theme .ec-modal__phone .auth-phone-field {
  background-color: #f5f6f7;
  border: 1px solid #e8eaed;
}

.ec-modal__phone .auth-phone-field.auth-phone-field--unified:focus-within {
  border-color: #ac8a50;
  box-shadow: none;
  outline: none;
  background: rgba(255, 255, 255, 0.08);
}

body.light_theme .ec-modal__phone .auth-phone-field.auth-phone-field--unified:focus-within {
  border-color: #343539;
  background: #ffffff;
}

.ec-modal__phone .auth-phone-field__country {
  flex: 0 0 auto;
  min-width: 0;
  max-width: 46%;
  display: flex;
  align-items: center;
}

.ec-modal__phone .auth-phone-field__country>div:first-child {
  flex: 1 1;
  min-width: 0;
  align-self: stretch;
  display: flex;
}

@media screen and (max-width: 400px) {
  .ec-modal__phone .auth-phone-field__country {
    max-width: 52%;
  }
}

.ec-modal__phone .auth-phone-field__divider {
  align-self: stretch;
  width: 1px;
  min-width: 1px;
  background: rgba(255, 255, 255, 0.12);
  margin: 10px 0;
  flex-shrink: 0;
}

body.light_theme .ec-modal__phone .auth-phone-field__divider {
  background: #dfe2e6;
}

.ec-modal__phone .auth-phone-field__number {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: stretch;
}

.ec-modal__phone .auth-phone-field__input.input_filed {
  flex: 1 1;
  width: 100%;
  min-width: 0;
  height: auto;
  min-height: 50px;
  margin: 0;
  border: none !important;
  border-radius: 0;
  background: transparent;
  box-shadow: none !important;
  padding-left: 10px;
  padding-right: 14px;
  font-size: 15px;
  color: #f0f0f0 !important;
}

body.light_theme .ec-modal__phone .auth-phone-field__input.input_filed {
  color: #1a1d21 !important;
}

.ec-modal__phone .auth-phone-field__input.input_filed:focus {
  outline: none;
}

.ec-modal__phone .auth-phone-country-inner {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.ec-modal__phone .auth-phone-country-flag {
  font-size: 1.1rem;
  line-height: 1;
}

.ec-modal__phone .auth-phone-country-code {
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.01em;
  color: #f0f0f0;
}

body.light_theme .ec-modal__phone .auth-phone-country-code {
  color: #1a1d21;
}

.ec-modal__phone .auth-phone-country__control {
  min-height: 50px !important;
  height: 100% !important;
  align-self: stretch;
  cursor: pointer;
}

.ec-modal__help {
  margin: 10px 0 0;
  padding: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #94a3b8;
  font-weight: 400;
  text-align: left;
}

body.light_theme .ec-modal__help {
  color: #6b7280;
}

.ec-modal__helpAccent {
  color: #d1aa67;
  font-weight: 600;
}

.ec-modal__help--warn {
  color: #b42318;
}

.ec-modal--verify .ec-modal__title {
  margin-top: 8px;
}

.ec-modal__block--verify {
  margin-top: 18px;
}

/* Login-style “Choose verification method” list */
.ec-verifyPick {
  margin: 20px 0 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ec-verifyPick__row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: #f0f0f0;
  transition: background 0.15s ease, border-color 0.15s ease;
}

body.light_theme .ec-verifyPick__row {
  border: 1px solid #e8eaed;
  background: #fff;
  color: #101828;
}

.ec-verifyPick__row:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

body.light_theme .ec-verifyPick__row:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.ec-verifyPick__row:focus-visible {
  outline: 2px solid #ac8a50;
  outline-offset: 2px;
}

.ec-verifyPick__left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.ec-verifyPick__icon {
  font-size: 22px;
  color: #4a5565;
  line-height: 1;
  margin-top: 2px;
}

.ec-verifyPick__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.ec-verifyPick__label {
  font-size: 15px;
  font-weight: 600;
  color: #101828;
}

.ec-verifyPick__desc {
  font-size: 13px;
  font-weight: 400;
  color: #6b7280;
  line-height: 1.35;
}

.ec-verifyPick__chev {
  font-size: 20px;
  color: #9ca3af;
  flex-shrink: 0;
}

.ec-modal__verifyRow {
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 0;
}

.ec-modal__input--verify {
  flex: 1 1;
}

.ec-modal__verifyRow--withSend .ec-modal__input--verify {
  padding-right: 76px;
}

.ec-modal__sendOtp {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 700;
  color: #ac8a50;
  cursor: pointer;
  padding: 6px 4px;
}

.ec-modal__sendOtp:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ec-modal__footer {
  margin: 28px 0 0;
  background-color: transparent !important;
  padding: 0;
}

.ec-modal__save {
  display: block;
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 999px;
  /* background: #efe6c8; */
  background: #2d2e32;
  /* color: #ffffff; */
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: not-allowed;
  box-sizing: border-box;
}

.ec-modal__save.is-enabled {
  color: #ffffff;
  cursor: pointer;
  /* text-shadow: 0 1px 0 rgba(0, 0, 0, 0.08); */
}

.ec-modal__save.is-enabled:hover {
  filter: brightness(1.04);
}

.ec-modal__save.is-enabled:active {
  filter: brightness(0.98);
}

.ec-modal__srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* —— Confirm Information step —— */

.ec-modal--confirm .ec-modal__title {
  margin-top: 0px;
}

.security-verification_img {
  max-width: 150px;
  margin: 0 auto;
  margin-bottom: 18px;
}

.ec-modal__lede {
  margin: 14px 0 0;
  padding: 0 2px 0 0;
  font-size: 14px;
  line-height: 1.55;
  color: #4b5563;
  font-weight: 400;
  text-align: left;
}

.ec-confirmCard {
  margin: 20px 0 0;
  padding: 18px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
}

.ec-confirmCard__nameRow {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f3f4f6;
}

.ec-confirmCard__nameIcon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f3f4f6;
  color: #374151;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.ec-confirmCard__nameText {
  font-size: 16px;
  font-weight: 600;
  color: #101828;
  line-height: 1.3;
}

.ec-confirmCard__block+.ec-confirmCard__block {
  margin-top: 14px;
}

.ec-confirmCard__label {
  font-size: 12px;
  font-weight: 500;
  color: #757575;
  margin-bottom: 4px;
}

.ec-confirmCard__value {
  font-size: 15px;
  font-weight: 600;
  color: #101828;
  word-break: break-word;
}

.ec-modal__footer--split {
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 24px;
}

.ec-modal__btnSecondary {
  flex: 1 1;
  min-height: 48px;
  border: none;
  border-radius: 12px;
  background: #f0f0f0;
  color: #101828;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.ec-modal__btnSecondary:hover {
  background: #e5e5e5;
}

.ec-modal__btnPrimary {
  flex: 1 1;
  min-height: 48px;
  border: none;
  border-radius: 12px;
  background: #2d2e32;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.ec-modal__btnPrimary:hover:not(:disabled) {
  filter: brightness(1.03);
}

.ec-modal__btnPrimary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (max-width: 767px) {


  .ec-modal-overlay {
    align-items: end;
    padding: 0px;
  }

  .ec-modal__phone .auth-phone-field__input.input_filed {
    font-size: 14px;
  }

  .ec-page__title {
    font-size: 20px;
    margin: 24px 0px 15px;
  }

  .ec-modal__input {
    font-size: 14px;
  }

  .ec-page__body {
    margin: 0 0 22px;
    font-size: 14px;
  }

  .ec-how__title {
    font-size: 14px;
  }

  .ec-page__art {
    max-width: 190px;
    margin: 30px auto;
    padding-top: 10px;
  }

  .ec-page__cta {
    height: 42px;
    font-size: 14px;
  }

  .ec-modal {
    padding: 14px 16px 18px;
    border-radius: 16px 16px 0px 0px;
    max-width: 100%;
  }

  .ec-modal__title {
    font-size: 20px;
  }

  .ec-modal__save {
    height: 42px;
    font-size: 14px;
  }

  .ec-modal__blockTitle {
    font-size: 14px;
  }

  .ec-modal__footer--split {
    flex-direction: column;
  }
}

/* —— Contact list —— */

.ec-list {
  max-width: 640px;
  margin: 0 auto 28px;
}

.ec-list__scroll {
  max-height: min(55vh, 480px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding-right: 2px;
  margin-right: -2px;
}

.ec-list__status {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #6b7280;
}

/* Visual-only loading (no “Loading contacts…” copy); label stays on role="status" for AT. */
.ec-list__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  padding: 24px 0;
}

.ec-list__items {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ec-card {
  border: 1px solid rgb(229 231 235 / 10%);
  border-radius: 12px;
  background: rgb(255 255 255 / 05%);
  padding: 16px 16px 14px;
}

body.light_theme .ec-card {
  border: 1px solid #e5e7eb;
  background: #fff;
}

.ec-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.ec-card__identity {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.ec-card__name {
  font-size: 16px;
  font-weight: 700;
  color: #f3f3f3;
}

body.light_theme .ec-card__name {
  color: #101828;
}

.ec-card__meta {
  font-size: 14px;
  font-weight: 500;
  color: #afafaf;
  word-break: break-word;
}

body.light_theme .ec-card__meta {
  color: #4b5563;
}

.ec-card__actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.ec-card__btn {
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.ec-card__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ec-card__btn--ghost {
  background: rgb(243 244 246 / 10%);
  color: #ffffff;
}

body.light_theme .ec-card__btn--ghost {
  background: #f3f4f6;
  color: #101828;
}

.ec-card__btn--ghost:hover:not(:disabled) {
  background: #e5e7eb;
}

.ec-card__btn--danger {
  background: #fef2f2;
  color: #b42318;
}

.ec-card__btn--danger:hover:not(:disabled) {
  background: #fee4e2;
}

.ec-card__btn--primary {
  background: #2d2e32;
  color: #fff;
}

.ec-card__btn--primary:hover:not(:disabled) {
  background: #1a1b1f;
}

.ec-card__msgLabel {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #d1d1d1;
  margin-bottom: 8px;
}

body.light_theme .ec-card__msgLabel {
  color: #374151;
}

.ec-card__textarea {
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid rgb(232 234 237 / 10%);
  background: rgb(249 250 251 / 10%);
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #cbcbcb;
  resize: vertical;
  min-height: 72px;
  outline: none;
}

body.light_theme .ec-card__textarea {
  border: 1px solid #e8eaed;
  background: #f9fafb;
  color: #101828;
}

/* .ec-card__textarea:focus {
  border-color: #cfd4dc;
  background: #fff;
} */

.ec-card__msgRow {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 520px) {
  .ec-card__top {
    flex-direction: column;
    align-items: stretch;
  }

  .ec-card__actions {
    justify-content: flex-end;
  }

  .ec-card__btn {
    padding: 6px 12px;
    font-size: 12px;
  }

  .ec-page__crumbList {
    font-size: 13px;
    font-weight: 400;
  }

  .ec-page__cta {
    height: 38px;
    font-size: 13px;
  }

}

/* —— Remove-contact confirmation (toast.custom) —— */

.ec-toast-confirm {
  width: min(100vw - 32px, 360px);
  background: #fcfcfc;
  color: #000;
  padding: 16px 18px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
}

.ec-toast-confirm__text {
  margin: 0 0 14px;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.45;
  color: #101828;
}

.ec-toast-confirm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.ec-toast-confirm__btn {
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.ec-toast-confirm__btn--ghost {
  background: #f3f4f6;
  color: #101828;
}

.ec-toast-confirm__btn--ghost:hover {
  background: #e5e7eb;
}

.ec-toast-confirm__btn--danger {
  background: #fef2f2;
  color: #b42318;
}

.ec-toast-confirm__btn--danger:hover {
  background: #fee4e2;
}

/* Fix autofill text color for emergency contact inputs */
.ec-modal__input:-webkit-autofill,
.ec-modal__input:-webkit-autofill:hover,
.ec-modal__input:-webkit-autofill:focus,
.ec-modal__input:-webkit-autofill:active,
.ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill,
.ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:hover,
.ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:focus,
.ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:active {
  -webkit-text-fill-color: #f0f0f0 !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

body.light_theme .ec-modal__input:-webkit-autofill,
body.light_theme .ec-modal__input:-webkit-autofill:hover,
body.light_theme .ec-modal__input:-webkit-autofill:focus,
body.light_theme .ec-modal__input:-webkit-autofill:active,
body.light_theme .ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill,
body.light_theme .ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:hover,
body.light_theme .ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:focus,
body.light_theme .ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:active {
  -webkit-text-fill-color: #101828 !important;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/emergencyContact.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;;;AAGF;;AAEA,mEAAmE;;AAEnE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,wFAAwF;EACxF,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;EAClC,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA,4FAA4F;AAC5F;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,qCAAqC;EACrC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,MAAM;AACR;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,mCAAmC;;AAEnC;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4FAA4F;AAC5F;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;AAEF;;AAEA,qDAAqD;;AAErD;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;;;;;;;;EAQE,2CAA2C;EAC3C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;;;;;;;;EAQE,2CAA2C;AAC7C","sourcesContent":["/* Emergency Contact page — scoped under .ec-page */\n\n.ec-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 35px 24px 48px;\n  max-width: 1190px;\n  margin: 0 auto;\n}\n\n.ec-page *,\n.ec-page *::before,\n.ec-page *::after {\n  box-sizing: border-box;\n}\n\n.ec-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.ec-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8e939c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.ec-page__crumbItem--active {\n  color: #e0e0e0;\n}\n\nbody.light_theme .ec-page__crumbItem--active {\n  color: #101828;\n}\n\n.ec-page__crumbSep {\n  color: #8e939c;\n}\n\n.ec-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.ec-page__crumbLink:hover {\n  color: #e9e9e9;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\nbody.light_theme .ec-page__crumbLink:hover {\n  color: #101828;\n}\n\n.ec-page__title {\n  margin: 42px 32px 28px;\n  font-size: 36px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #e2e2e2;\n  text-align: left;\n}\n\nbody.light_theme .ec-page__title {\n  color: #2d2e32;\n}\n\n.ec-page__art {\n  max-width: 220px;\n  display: flex;\n  justify-content: center;\n  margin: 50px auto;\n  justify-content: center;\n  align-items: center;\n  padding-top: 40px;\n}\n\n.ec-page__artImg {\n  width: min(280px, 86vw);\n  height: auto;\n  display: block;\n}\n\n.ec-page__body {\n  margin: 0 0 28px;\n  font-size: 18px;\n  line-height: 1.65;\n  font-weight: 500;\n  color: #919191;\n  text-align: left;\n  max-width: 640px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\nbody.light_theme .ec-page__body {\n  color: #4a5565;\n}\n\n.ec-how {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px 18px;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  background: #fff;\n  margin: 0 0 28px;\n  max-width: 640px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ec-how__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 8px;\n  background: #f3f4f6;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #4a5565;\n  font-size: 22px;\n  flex-shrink: 0;\n}\n\n.ec-how__text {\n  min-width: 0;\n}\n\n.ec-how__title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #2d2e32;\n  margin-bottom: 2px;\n}\n\n.ec-how__learn {\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: #ac8a50;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.ec-page__cta {\n  display: block;\n  width: 100%;\n  max-width: 640px;\n  margin: 0 auto;\n  height: 50px;\n  border: none;\n  border-radius: 999px;\n  background: #2d2e32;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.ec-page__cta:hover {\n  opacity: 0.8;\n}\n\n@media (max-width: 520px) {\n  .ec-page {\n    padding: 30px 16px 40px;\n  }\n\n\n}\n\n/* —— Add Emergency Contact modal (layout aligned with design) —— */\n\n.ec-modal-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  box-sizing: border-box;\n  /* Below App.js <Toaster containerStyle zIndex> so react-hot-toast errors stay visible */\n  z-index: 999999999;\n  background-color: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\nbody.light_theme .ec-modal-overlay {\n  background-color: rgb(255 255 255 / 20%);\n}\n\n.ec-modal {\n  width: 100%;\n  max-width: 510px;\n  max-height: min(92vh, 720px);\n  overflow-y: auto;\n  background: #1e202670;\n  border-radius: 20px;\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n  padding: 16px 20px 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);\n  position: relative;\n}\n\nbody.light_theme .ec-modal {\n  background: rgb(255 255 255 / 20%);\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);\n}\n\n.ec-modal__header {\n  position: relative;\n  min-height: 40px;\n  margin: 0;\n  background-color: transparent !important;\n  padding: 0;\n}\n\n.ec-modal__back {\n  position: absolute;\n  left: -4px;\n  top: 0;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background: transparent;\n  border-radius: 10px;\n  color: #f0f0f0;\n  font-size: 24px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.light_theme .ec-modal__back {\n  color: #101828;\n}\n\n.ec-modal__back:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .ec-modal__back:hover {\n  background: #f3f4f6;\n}\n\n.ec-modal__back:focus-visible {\n  outline: 2px solid #ac8a50;\n  outline-offset: 2px;\n}\n\n.ec-modal__title {\n  margin: 0px 0 0;\n  padding: 0 0 0 2px;\n  font-size: 24px;\n  font-weight: 600;\n  color: #ffffff;\n  letter-spacing: -0.03em;\n  line-height: 1.25;\n  text-align: left;\n}\n\nbody.light_theme .ec-modal__title {\n  color: #101828;\n}\n\n.ec-modal__form {\n  margin: 0;\n  padding: 0;\n}\n\n.ec-modal__block {\n  margin: 24px 0 0;\n  padding: 0;\n  border: none;\n}\n\n.ec-modal__block:first-of-type {\n  margin-top: 22px;\n}\n\n.ec-modal__blockTitle {\n  margin: 0 0 10px;\n  padding: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #f0f0f0;\n  text-align: left;\n  line-height: 1.3;\n}\n\nbody.light_theme .ec-modal__blockTitle {\n  color: #101828;\n}\n\n.ec-modal__input {\n  display: block;\n  width: 100%;\n  height: 50px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.04);\n  padding: 0 16px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #f0f0f0 !important;\n  outline: none;\n  box-sizing: border-box;\n}\n\nbody.light_theme .ec-modal__input {\n  border: 1px solid #e8eaed;\n  background: #f3f4f6;\n  color: #3c3c3c !important;\n}\n\n.ec-modal__input::placeholder {\n  color: #94a3b8;\n  font-weight: 500;\n}\n\nbody.light_theme .ec-modal__input::placeholder {\n  color: #3c3c3c !important;\n}\n\n.ec-modal__input:focus {\n  border-color: #ac8a50;\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .ec-modal__input:focus {\n  border-color: #cfd4dc;\n  background: #ffffff;\n}\n\n.ec-modal__contactStack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.ec-modal__row {\n  margin: 0;\n}\n\n.ec-modal__phone {\n  width: 100%;\n}\n\n/* Unified phone row — same horizontal layout as login/signup (country | divider | number) */\n.ec-modal__phone .auth-phone-field {\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 50px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.04);\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\nbody.light_theme .ec-modal__phone .auth-phone-field {\n  background-color: #f5f6f7;\n  border: 1px solid #e8eaed;\n}\n\n.ec-modal__phone .auth-phone-field.auth-phone-field--unified:focus-within {\n  border-color: #ac8a50;\n  box-shadow: none;\n  outline: none;\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .ec-modal__phone .auth-phone-field.auth-phone-field--unified:focus-within {\n  border-color: #343539;\n  background: #ffffff;\n}\n\n.ec-modal__phone .auth-phone-field__country {\n  flex: 0 0 auto;\n  min-width: 0;\n  max-width: 46%;\n  display: flex;\n  align-items: center;\n}\n\n.ec-modal__phone .auth-phone-field__country>div:first-child {\n  flex: 1;\n  min-width: 0;\n  align-self: stretch;\n  display: flex;\n}\n\n@media screen and (max-width: 400px) {\n  .ec-modal__phone .auth-phone-field__country {\n    max-width: 52%;\n  }\n}\n\n.ec-modal__phone .auth-phone-field__divider {\n  align-self: stretch;\n  width: 1px;\n  min-width: 1px;\n  background: rgba(255, 255, 255, 0.12);\n  margin: 10px 0;\n  flex-shrink: 0;\n}\n\nbody.light_theme .ec-modal__phone .auth-phone-field__divider {\n  background: #dfe2e6;\n}\n\n.ec-modal__phone .auth-phone-field__number {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  align-items: stretch;\n}\n\n.ec-modal__phone .auth-phone-field__input.input_filed {\n  flex: 1;\n  width: 100%;\n  min-width: 0;\n  height: auto;\n  min-height: 50px;\n  margin: 0;\n  border: none !important;\n  border-radius: 0;\n  background: transparent;\n  box-shadow: none !important;\n  padding-left: 10px;\n  padding-right: 14px;\n  font-size: 15px;\n  color: #f0f0f0 !important;\n}\n\nbody.light_theme .ec-modal__phone .auth-phone-field__input.input_filed {\n  color: #1a1d21 !important;\n}\n\n.ec-modal__phone .auth-phone-field__input.input_filed:focus {\n  outline: none;\n}\n\n.ec-modal__phone .auth-phone-country-inner {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.ec-modal__phone .auth-phone-country-flag {\n  font-size: 1.1rem;\n  line-height: 1;\n}\n\n.ec-modal__phone .auth-phone-country-code {\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: -0.01em;\n  color: #f0f0f0;\n}\n\nbody.light_theme .ec-modal__phone .auth-phone-country-code {\n  color: #1a1d21;\n}\n\n.ec-modal__phone .auth-phone-country__control {\n  min-height: 50px !important;\n  height: 100% !important;\n  align-self: stretch;\n  cursor: pointer;\n}\n\n.ec-modal__help {\n  margin: 10px 0 0;\n  padding: 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: #94a3b8;\n  font-weight: 400;\n  text-align: left;\n}\n\nbody.light_theme .ec-modal__help {\n  color: #6b7280;\n}\n\n.ec-modal__helpAccent {\n  color: #d1aa67;\n  font-weight: 600;\n}\n\n.ec-modal__help--warn {\n  color: #b42318;\n}\n\n.ec-modal--verify .ec-modal__title {\n  margin-top: 8px;\n}\n\n.ec-modal__block--verify {\n  margin-top: 18px;\n}\n\n/* Login-style “Choose verification method” list */\n.ec-verifyPick {\n  margin: 20px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ec-verifyPick__row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.04);\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  color: #f0f0f0;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\nbody.light_theme .ec-verifyPick__row {\n  border: 1px solid #e8eaed;\n  background: #fff;\n  color: #101828;\n}\n\n.ec-verifyPick__row:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\nbody.light_theme .ec-verifyPick__row:hover {\n  background: #f9fafb;\n  border-color: #d1d5db;\n}\n\n.ec-verifyPick__row:focus-visible {\n  outline: 2px solid #ac8a50;\n  outline-offset: 2px;\n}\n\n.ec-verifyPick__left {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-width: 0;\n}\n\n.ec-verifyPick__icon {\n  font-size: 22px;\n  color: #4a5565;\n  line-height: 1;\n  margin-top: 2px;\n}\n\n.ec-verifyPick__text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.ec-verifyPick__label {\n  font-size: 15px;\n  font-weight: 600;\n  color: #101828;\n}\n\n.ec-verifyPick__desc {\n  font-size: 13px;\n  font-weight: 400;\n  color: #6b7280;\n  line-height: 1.35;\n}\n\n.ec-verifyPick__chev {\n  font-size: 20px;\n  color: #9ca3af;\n  flex-shrink: 0;\n}\n\n.ec-modal__verifyRow {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n}\n\n.ec-modal__input--verify {\n  flex: 1;\n}\n\n.ec-modal__verifyRow--withSend .ec-modal__input--verify {\n  padding-right: 76px;\n}\n\n.ec-modal__sendOtp {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 700;\n  color: #ac8a50;\n  cursor: pointer;\n  padding: 6px 4px;\n}\n\n.ec-modal__sendOtp:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ec-modal__footer {\n  margin: 28px 0 0;\n  background-color: transparent !important;\n  padding: 0;\n}\n\n.ec-modal__save {\n  display: block;\n  width: 100%;\n  height: 52px;\n  border: none;\n  border-radius: 999px;\n  /* background: #efe6c8; */\n  background: #2d2e32;\n  /* color: #ffffff; */\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  cursor: not-allowed;\n  box-sizing: border-box;\n}\n\n.ec-modal__save.is-enabled {\n  color: #ffffff;\n  cursor: pointer;\n  /* text-shadow: 0 1px 0 rgba(0, 0, 0, 0.08); */\n}\n\n.ec-modal__save.is-enabled:hover {\n  filter: brightness(1.04);\n}\n\n.ec-modal__save.is-enabled:active {\n  filter: brightness(0.98);\n}\n\n.ec-modal__srOnly {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* —— Confirm Information step —— */\n\n.ec-modal--confirm .ec-modal__title {\n  margin-top: 0px;\n}\n\n.security-verification_img {\n  max-width: 150px;\n  margin: 0 auto;\n  margin-bottom: 18px;\n}\n\n.ec-modal__lede {\n  margin: 14px 0 0;\n  padding: 0 2px 0 0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #4b5563;\n  font-weight: 400;\n  text-align: left;\n}\n\n.ec-confirmCard {\n  margin: 20px 0 0;\n  padding: 18px 16px;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.ec-confirmCard__nameRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.ec-confirmCard__nameIcon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: #f3f4f6;\n  color: #374151;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.ec-confirmCard__nameText {\n  font-size: 16px;\n  font-weight: 600;\n  color: #101828;\n  line-height: 1.3;\n}\n\n.ec-confirmCard__block+.ec-confirmCard__block {\n  margin-top: 14px;\n}\n\n.ec-confirmCard__label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #757575;\n  margin-bottom: 4px;\n}\n\n.ec-confirmCard__value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #101828;\n  word-break: break-word;\n}\n\n.ec-modal__footer--split {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.ec-modal__btnSecondary {\n  flex: 1;\n  min-height: 48px;\n  border: none;\n  border-radius: 12px;\n  background: #f0f0f0;\n  color: #101828;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ec-modal__btnSecondary:hover {\n  background: #e5e5e5;\n}\n\n.ec-modal__btnPrimary {\n  flex: 1;\n  min-height: 48px;\n  border: none;\n  border-radius: 12px;\n  background: #2d2e32;\n  color: #ffffff;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ec-modal__btnPrimary:hover:not(:disabled) {\n  filter: brightness(1.03);\n}\n\n.ec-modal__btnPrimary:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n@media (max-width: 767px) {\n\n\n  .ec-modal-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .ec-modal__phone .auth-phone-field__input.input_filed {\n    font-size: 14px;\n  }\n\n  .ec-page__title {\n    font-size: 20px;\n    margin: 24px 0px 15px;\n  }\n\n  .ec-modal__input {\n    font-size: 14px;\n  }\n\n  .ec-page__body {\n    margin: 0 0 22px;\n    font-size: 14px;\n  }\n\n  .ec-how__title {\n    font-size: 14px;\n  }\n\n  .ec-page__art {\n    max-width: 190px;\n    margin: 30px auto;\n    padding-top: 10px;\n  }\n\n  .ec-page__cta {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .ec-modal {\n    padding: 14px 16px 18px;\n    border-radius: 16px 16px 0px 0px;\n    max-width: 100%;\n  }\n\n  .ec-modal__title {\n    font-size: 20px;\n  }\n\n  .ec-modal__save {\n    height: 42px;\n    font-size: 14px;\n  }\n\n  .ec-modal__blockTitle {\n    font-size: 14px;\n  }\n\n  .ec-modal__footer--split {\n    flex-direction: column;\n  }\n}\n\n/* —— Contact list —— */\n\n.ec-list {\n  max-width: 640px;\n  margin: 0 auto 28px;\n}\n\n.ec-list__scroll {\n  max-height: min(55vh, 480px);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  padding-right: 2px;\n  margin-right: -2px;\n}\n\n.ec-list__status {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.5;\n  color: #6b7280;\n}\n\n/* Visual-only loading (no “Loading contacts…” copy); label stays on role=\"status\" for AT. */\n.ec-list__loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 120px;\n  padding: 24px 0;\n}\n\n.ec-list__items {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.ec-card {\n  border: 1px solid rgb(229 231 235 / 10%);\n  border-radius: 12px;\n  background: rgb(255 255 255 / 05%);\n  padding: 16px 16px 14px;\n}\n\nbody.light_theme .ec-card {\n  border: 1px solid #e5e7eb;\n  background: #fff;\n}\n\n.ec-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.ec-card__identity {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.ec-card__name {\n  font-size: 16px;\n  font-weight: 700;\n  color: #f3f3f3;\n}\n\nbody.light_theme .ec-card__name {\n  color: #101828;\n}\n\n.ec-card__meta {\n  font-size: 14px;\n  font-weight: 500;\n  color: #afafaf;\n  word-break: break-word;\n}\n\nbody.light_theme .ec-card__meta {\n  color: #4b5563;\n}\n\n.ec-card__actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.ec-card__btn {\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ec-card__btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.ec-card__btn--ghost {\n  background: rgb(243 244 246 / 10%);\n  color: #ffffff;\n}\n\nbody.light_theme .ec-card__btn--ghost {\n  background: #f3f4f6;\n  color: #101828;\n}\n\n.ec-card__btn--ghost:hover:not(:disabled) {\n  background: #e5e7eb;\n}\n\n.ec-card__btn--danger {\n  background: #fef2f2;\n  color: #b42318;\n}\n\n.ec-card__btn--danger:hover:not(:disabled) {\n  background: #fee4e2;\n}\n\n.ec-card__btn--primary {\n  background: #2d2e32;\n  color: #fff;\n}\n\n.ec-card__btn--primary:hover:not(:disabled) {\n  background: #1a1b1f;\n}\n\n.ec-card__msgLabel {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #d1d1d1;\n  margin-bottom: 8px;\n}\n\nbody.light_theme .ec-card__msgLabel {\n  color: #374151;\n}\n\n.ec-card__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border-radius: 10px;\n  border: 1px solid rgb(232 234 237 / 10%);\n  background: rgb(249 250 251 / 10%);\n  padding: 10px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #cbcbcb;\n  resize: vertical;\n  min-height: 72px;\n  outline: none;\n}\n\nbody.light_theme .ec-card__textarea {\n  border: 1px solid #e8eaed;\n  background: #f9fafb;\n  color: #101828;\n}\n\n/* .ec-card__textarea:focus {\n  border-color: #cfd4dc;\n  background: #fff;\n} */\n\n.ec-card__msgRow {\n  margin-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 520px) {\n  .ec-card__top {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ec-card__actions {\n    justify-content: flex-end;\n  }\n\n  .ec-card__btn {\n    padding: 6px 12px;\n    font-size: 12px;\n  }\n\n  .ec-page__crumbList {\n    font-size: 13px;\n    font-weight: 400;\n  }\n\n  .ec-page__cta {\n    height: 38px;\n    font-size: 13px;\n  }\n\n}\n\n/* —— Remove-contact confirmation (toast.custom) —— */\n\n.ec-toast-confirm {\n  width: min(100vw - 32px, 360px);\n  background: #fcfcfc;\n  color: #000;\n  padding: 16px 18px;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e5e7eb;\n}\n\n.ec-toast-confirm__text {\n  margin: 0 0 14px;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.45;\n  color: #101828;\n}\n\n.ec-toast-confirm__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.ec-toast-confirm__btn {\n  border: none;\n  border-radius: 8px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.ec-toast-confirm__btn--ghost {\n  background: #f3f4f6;\n  color: #101828;\n}\n\n.ec-toast-confirm__btn--ghost:hover {\n  background: #e5e7eb;\n}\n\n.ec-toast-confirm__btn--danger {\n  background: #fef2f2;\n  color: #b42318;\n}\n\n.ec-toast-confirm__btn--danger:hover {\n  background: #fee4e2;\n}\n\n/* Fix autofill text color for emergency contact inputs */\n.ec-modal__input:-webkit-autofill,\n.ec-modal__input:-webkit-autofill:hover,\n.ec-modal__input:-webkit-autofill:focus,\n.ec-modal__input:-webkit-autofill:active,\n.ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill,\n.ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:hover,\n.ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:focus,\n.ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:active {\n  -webkit-text-fill-color: #f0f0f0 !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\nbody.light_theme .ec-modal__input:-webkit-autofill,\nbody.light_theme .ec-modal__input:-webkit-autofill:hover,\nbody.light_theme .ec-modal__input:-webkit-autofill:focus,\nbody.light_theme .ec-modal__input:-webkit-autofill:active,\nbody.light_theme .ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill,\nbody.light_theme .ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:hover,\nbody.light_theme .ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:focus,\nbody.light_theme .ec-modal__phone .auth-phone-field__input.input_filed:-webkit-autofill:active {\n  -webkit-text-fill-color: #101828 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
